import documentsicon from "../../../../../assets/images/description.svg";
import useHomeFlow from "../../../../../hooks/useHomeFlowSimple";
import useLanguageTranslate from "../../../../../hooks/useLanguageTranslate";
import BottomStickyBtnLayout from "../../../../../pages/motorInsurancePages/newMotorPolicy/Layouts/BottomStickyBtnLayout";
import NewHomeJourneyLayout from "../../../layouts/NewHomeJourneyLayout";
import InfoCard from "./infoCard";

const DocumentsReadyInfo = ({
  continueClickHandler,
  hide_back_btn,
  show_close_btn,
  onClose,
}) => {
  const translate = useLanguageTranslate();
  const { handlePrevSubstep } = useHomeFlow();

  return (
    <div className="documents-ready-info w-full">
      <NewHomeJourneyLayout
        show_close_btn={show_close_btn}
        is_hide_back_btn={hide_back_btn}
        customBackHandler={!hide_back_btn ? handlePrevSubstep : undefined}
        onClose={onClose}
        isFirstPage={show_close_btn}
      >
        <BottomStickyBtnLayout
          btn_onClick={continueClickHandler}
          btn_label={translate("Continue", "التالي")}
          passedFrom="HomeInsurance"
        >
          <div className="w-[32%] max767:w-full mx-auto ipad:min-w-[66%]">
            <h1 className="text-[#1A2024] text-center text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] max767:text-left  max767:rtl:text-right">
              {translate(
                "Ready to Start Your New Policy?",
                "هل أنت مستعد لبدء وثيقتك الجديدة ؟"
              )}
            </h1>
            <p className="text-[#1A2024] text-center text-base not-italic font-normal leading-6 tracking-[-0.16px] mb-6 max767:text-left  max767:rtl:text-right">
              {translate(
                "Please ensure you have the following information and documents ready for smooth process.",
                "يرجى التأكد من أن لديك المعلومات والمستندات التالية جاهزة لعملية سلسة."
              )}
            </p>
            <div className="infoCards mb-6">
              <InfoCard
                title={translate("Required Documents", "المستندات")}
                title_icon={documentsicon}
                infoData={[
                  {
                    en_label: "CPR Bahraini National ID",
                    ar_label: "رقم الهوية الوطنية (CPR)",
                    hasInfo: false,
                  },
                ]}
              />
            </div>
          </div>
        </BottomStickyBtnLayout>
      </NewHomeJourneyLayout>
    </div>
  );
};

export default DocumentsReadyInfo;
